/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "../Dashboard/Dashboard.css";
import { ChartPage, BarChart } from "./dashboardchart";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { showErrorAlert } from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import { Link } from "react-router-dom";
import defaultImg from "../../../../assets/img/no_user.jpg";

export default function Dashboard() {
  const [userData, setUserData] = useState();
  const [DataCount, setDataCount] = useState();
  const [UserGraphData, setUserGraphData] = useState();
  const [OrderGraphData, setOrderGraphData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserList();
    DashboardCount();
    // UsersGraph()
  }, []);

  const getUserList = async () => {
    setLoading(true);
    const data = {
      limit: 5,
      sorting: "sortingKey|desc",
      page: 0,
    };
    PostService(API_URL.GET_ALL_USER, data).then(
      (res) => {
        if (res.data.status === true) {
          setUserData(res.data.data.rows);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const DashboardCount = async () => {
    setLoading(true);

    GetService(API_URL.GET_DASHBOARD_COUNT).then((res) => {
      console.log(res);
      if (res.data.status === true) {
        setDataCount(res.data.data);
        setUserGraphData(res.data.data.user_graph);
        setOrderGraphData(res.data.data.order_graph);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  // const UsersGraph = async()=>{
  //   setLoading(true);

  //   GetService(API_URL.GET_USER_GRAPH_DATA).then(
  //     (res)=>{
  //       console.log(res)
  //       if (res.data.status === true) {
  //         setUserGraphData(res.data.data);
  //         setLoading(false);
  //       } else {
  //         showErrorAlert(res.data?.message);
  //         setLoading(false);
  //       }
  //     }
  //   )
  // }

  return (
    <div>
      <div className="">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 mb-3">
                <h3 className="m-0">Dashboard</h3>
              </div>
              {/* <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item active">Dashboard</li>
                </ol>
              </div> */}
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12  transparent">
                <div className="row">
                  <div className="col-md-3 mb-4 stretch-card transparent">
                    <div className="card card-tale">
                      <Link
                        to={"/panel/user"}
                        className="card-body"
                        style={{ color: "white" }}
                      >
                        <div className="row">
                        <div className="col-md-9">
                        <p className="font-weight-bold mb-4">Total Users</p>
                        <p className="fs-30 mb-2">
                          {DataCount?.total_users || "N/A"}
                        </p>
                        </div>
                        <div className="col-md-3">
                        <i class="fa fa-users" ></i>
                        </div>
                      </div> 
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3  mb-4 stretch-card transparent">
                    <div className="card card-dark-blue">
                      <Link
                        to={"/panel/product"}
                        className="card-body"
                        style={{ color: "white" }}
                      >
                         <div className="row">
                        <div className="col-md-9"> 
                        <p className="font-weight-bold mb-4">Total Revenue</p>
                        <p className="fs-30 mb-2">
                          {DataCount?.total_product2 || "N/A"}
                        </p> 
                        </div>
                        <div className="col-md-3">
                        <i class="fa fa-usd" ></i>
                        </div>
                      </div> 
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4 stretch-card transparent">
                    <div className="card card-light-blue">
                      <Link
                        to={"/panel/order"}
                        className="card-body"
                        style={{ color: "white" }}
                      > 
                      <div className="row">
                      <div className="col-md-9">
                        <p className="font-weight-bold mb-4">Total Orders</p>
                        <p className="fs-30 mb-2">
                          {DataCount?.total_order || "N/A"}
                        </p>
                        </div>
                        <div className="col-md-3">
                        <i class="fa fa-shopping-cart" ></i>
                        </div>
                      </div> 
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4   stretch-card transparent">
                    <div className="card card-light-danger">
                      <Link
                        to={"/panel/transaction"}
                        className="card-body"
                        style={{ color: "white" }}
                      >
                         <div className="row">
                        <div className="col-md-9"> 
                        <p className="font-weight-bold mb-4">
                          Total Transactions
                        </p>
                        <p className="fs-30 mb-2">{DataCount?.total_transaction || 'N/A'}</p>
                       
                        </div>
                        <div className="col-md-3">
                        <i class="fa fa-exchange" ></i>
                        </div>
                      </div> 
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <div className="chartjs-size-monitor">
                      <div className="chartjs-size-monitor-expand">
                        <div className />
                      </div>
                      <div className="chartjs-size-monitor-shrink">
                        <div className />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="card-title">Users Graph</p>
                      {/* <a href="#" className="text-info">
                        View all
                      </a> */}
                    </div>
                    <p className="font-weight-500">
                      The total number of users within the date range. It is the
                      period time a user is actively engaged with your website,
                      page or app, etc
                    </p>
                    <div id="sales-legend" className="chartjs-legend mt-4 mb-4">
                      <ul className="1-legend">
                        {/* <li>
                          <span
                            style={{ backgroundColor: "rgb(152, 189, 255)" }}
                          />
                          Offline Sales
                        </li> */}
                        <li>
                          <span
                            style={{ backgroundColor: "rgb(75, 73, 172)" }}
                          />
                          Users
                        </li>
                      </ul>
                    </div>
                    <div className="App">
                      {UserGraphData ? (
                        <BarChart UserGraphData={UserGraphData} />
                      ) : (
                        <p>Loading data...</p>
                      )}
                    </div>

                    {/* <canvas
                      id="sales-chart"
                      width={501}
                      height={250}
                      style={{ display: "block", width: 501, height: 250 }}
                      className="chartjs-render-monitor"
                    /> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <div className="chartjs-size-monitor">
                      <div className="chartjs-size-monitor-expand">
                        <div className />
                      </div>
                      <div className="chartjs-size-monitor-shrink">
                        <div className />
                      </div>
                    </div>
                    <p className="card-title">Orders Graph</p>
                    <p className="font-weight-500">
                      The total number of orders within the date range. It is
                      the period of time a user is actively orders with your
                      website , page or app , etc.
                    </p>
                    {/* <div className="d-flex flex-wrap mb-5">
                      <div className="mr-5 mt-3">
                        <p className="text-muted">Order value</p>
                        <h3 className="text-primary fs-20 font-weight-medium text-small">
                          12.3k
                        </h3>
                      </div>
                      <div className="mr-5 mt-3">
                        <p className="text-muted">Orders</p>
                        <h3 className="text-primary fs-20 text-small font-weight-medium">
                          14k
                        </h3>
                      </div>
                      <div className="mr-5 mt-3">
                        <p className="text-muted">Users</p>
                        <h3 className="text-primary fs-20 text-small font-weight-medium">
                          71.56%
                        </h3>
                      </div>
                      <div className="mt-3">
                        <p className="text-muted">Downloads</p>
                        <h3 className="text-primary fs-20 text-small font-weight-medium">
                          34040
                        </h3>
                      </div>
                    </div> */}
                    <div id="sales-legend" className="chartjs-legend mt-4 mb-4">
                      <ul className="1-legend">
                        {/* <li>
                          <span
                            style={{ backgroundColor: "rgb(152, 189, 255)" }}
                          />
                          Offline Sales
                        </li> */}
                        <li>
                          <span
                            style={{ backgroundColor: "rgb(75, 73, 172)" }}
                          />
                          Orders
                        </li>
                      </ul>
                    </div>
                    <div className="App">
                      {OrderGraphData ? (
                        <ChartPage OrderGraphData={OrderGraphData} />
                      ) : (
                        <p>Loading data...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <p class="card-title">Latest Users</p>
                    <div className="row px-3">
                      <div class="table-responsive mt-3">
                        {!loading && (
                          <table class="table table-hover table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Profile</th>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>Country</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userData &&
                                userData?.map((item, i) => (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>
                                    <div className="user-profile-container">
                                    <img
                                      src={item?.profile ? item?.profile : ""}
                                      alt=""
                                      onError={(e) => {
                                        e.target.src = defaultImg;
                                      }}
                                    className="user-profile-image"
                                    />
                                    </div>
                                  </td>
                                    <td>
                                      {item?.fname && item?.lname && (
                                        <span>
                                          {item?.fname} {item?.lname}
                                        </span>
                                      )}
                                      {!item?.fname && !item?.lname && (
                                        <span>{item?.fullName || 'N/A'}</span>
                                      )}
                                    </td>
                                    <td>{item?.email}</td>
                                    <td>
                                      {" "}
                                      <p>
                                        {item?.country
                                          ? item?.country
                                          : item?.country_id
                                          ? item?.country_id
                                          : "N/A"}
                                      </p>
                                    </td>
                                    <td>
                                      <label
                                        className={
                                          item?.status === "active"
                                            ? "badge badge-success"
                                            : "badge badge-danger"
                                        }
                                      >
                                        {item?.status === "active"
                                          ? "Active"
                                          : "Inactive"}
                                      </label>
                                    </td>
                                  </tr>
                                ))}
                              {userData && userData.length === 0 && (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    <h6 className="p-3"> No Data Found </h6>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}

                        {loading ? (
                          <div className="LoaderSpinner">
                            <MoonLoader
                              color={"#003bff"}
                              loading={loading}
                              speedMultiplier={0.6}
                              size={50}
                            />
                            <div>Loading... Please wait.</div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* / DELETE MODAL-------------------- / */}
      <div
        className="modal fade"
        id="DeleteModal"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Delete Category !
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <h6> Are you sure you want to delete this Category ? </h6>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                id="DeleteModal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-danger">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* / DELETE MODAL- End ------------------- / */}
    </div>
  );
}
